export default __webpack_public_path__ + "static/media/IMAGEM DOS PRODUTOS - MOTOROLA.dec0ffa1.png";